// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 33377 ? "977f774c" : chunkId) + "." + {"31257":"e39f295ad12d2410","33377":"ee435d416ec5fa74","63973":"b15be42de51c756a"}[chunkId] + ".js";
};